import { createLazyComponent, LazyImport, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "GroupFavoriteButton" */ './lazyIndex');
});
// Delay loaded components
export var GroupFavoriteButton = createLazyComponent(lazyModule, function (m) { return m.GroupFavoriteButton; });
export var lazyToggleFavoriteGroup = new LazyImport(lazyModule, function (m) { return m.toggleFavoriteGroup; });
//# sourceMappingURL=index.js.map